module.exports = __webpack_public_path__ + "static/media/month.55fa70e4.png";